import React, { useState } from 'react';
import image from "../assets/images/bhs-front.png"

function Contact(props) {

    const [linkCopied, setLinkCopied] = useState(false);

    async function copyToClipboard(text) {
        try {
            await navigator.clipboard.writeText(text);
            console.log('Text copied to clipboard successfully!');
        } catch (err) {
            console.error('Failed to copy text: ', err);
        }
    }

    const emailLinkClick = () => {
        setLinkCopied(true);
        copyToClipboard("khersh@bhspa.net")
    }

    const copiedTextStyles = {
        opacity: 0.5,
        fontSize: 12,
        marginLeft: 6
    }

    return (
        <div className='Contact'>
            <span className='Scroll-Target Contact-Scroll'></span>
            <div className='Image-Cont'></div>
            <div className='Spacer'></div>
            <div className='Content'>
                <div>
                    <p>Our office is located at</p>
                    <a href="https://goo.gl/maps/eUfV2QCkFT8hP1Wj8">5318 Highgate Drive, Suite 131, Durham, NC 27713</a>
                </div>
                <div>
                    <p>Phone: <a href="tel:9194190524">919-419-0524</a></p>
                    <p>Email: <a onMouseDown={emailLinkClick}>khersh@bhspa.net</a> {linkCopied ? <span style={copiedTextStyles}>Link Copied</span>: ""}</p>
                    <p>Fax: <a>919-419-9651</a></p>
                </div>
            </div>
        </div>
    );
}

export default Contact;